/* eslint-disable camelcase */
import { confirmed, email, alpha_num, alpha_dash, integer, digits, numeric, min, max, min_value, max_value, length, required } from '@vee-validate/rules'
import { configure } from 'vee-validate'
import { applyRules, getRules } from '~/utils/validation/rules'
import { useLocaleStore } from '~/stores/locale'

export default defineNuxtPlugin(() => {

  const i18n = useI18n()
  /* eslint camelcase: ["error", {allow: ["^alpha_"]}] */
  const veeValidateRules = {
    confirmed,
    email,
    length,
    max,
    min_value,
    max_value,
    alpha_dash,
    integer,
    min,
    digits,
    alpha_num,
    numeric,
    required
  }
  applyRules(veeValidateRules)
  // The amount rules take only the culture's own decimal separator, read when a
  // field validates so a culture switch needs no re-registration.
  //
  // The registry is process-wide, so on the server each request replaces these
  // rules with ones bound to its own i18n and store. That is safe only because
  // nothing validates while rendering on the server: vee-validate runs rules
  // from onMounted and from input events.
  const localeStore = useLocaleStore()
  applyRules(getRules(i18n, () => localeStore.culture))

  configure({
    // this will be used to generate messages.
    generateMessage: (context ) => {
      const params: Record<string, unknown> = { _field_: context.field }
      // Merge rule params so messages can interpolate e.g. {length}
      if (context.rule?.params) {
        if (Array.isArray(context.rule.params)) {
          const paramNames: Record<string, string[]> = { length: ['length'], min: ['length'], max: ['length'] }
          const names = paramNames[context.rule.name] || []
          context.rule.params.forEach((val: unknown, idx: number) => {
            if (names[idx]) params[names[idx]] = val
          })
        } else {
          Object.assign(params, context.rule.params)
        }
      }
      return i18n.ts(`validations.${context.rule?.name}`, params as Parameters<typeof i18n.ts>[1])
    }
  })
})
